<template>
  <button
    class="flex flex-row border border-1 border-GREY rounded-lg p-3 items-center justify-between w-full"
    @click="emit('itemClick')"
  >
    <div class="flex flex-row justify-start items-center gap-2">
      <div v-if="props.svgIcon" class="min-w-10 flex flex-col items-center">
        <img :src="props.svgIcon" class="h-full object-contain" :class="IconSize" />
      </div>
      <div v-else-if="props.icon" class="min-w-10 flex flex-col items-center">
        <div
          class="rounded-full w-9 h-9 items-center justify-center flex"
          :class="props.delete ? ' bg-[#ECC0C0]' : 'bg-LIGHTGREY'"
        >
          <font-awesome-icon class="black-icon" :icon="props.icon" />
        </div>
      </div>
      <div class="flex flex-col gap-0.5 items-start justify-center">
        <p class="font-semibold text-sm">{{ props.title }}</p>
        <slot></slot>
      </div>
    </div>
    <slot name="suffix"></slot>
  </button>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  icon: {
    type: String,
    default: ''
  },
  svgIcon: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: 'Title'
  },
  size: {
    type: String,
    default: 'md'
  },
  delete: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['itemClick'])

const IconSize = computed(() => [
  {
    'w-11 h-11 !p-0': props.size == 'lg',
    'w-10 h-10 !p-0': props.size == 'md',
    'w-8 h-8 !p-0': props.size == 'sm',
    'w-9 h-9 !p-0': props.size == 'xs'
  }
])
</script>

<style></style>
